// extracted by mini-css-extract-plugin
export default {"numeric-input":"NumericInput__numeric-input__wvn7B","numericInput":"NumericInput__numeric-input__wvn7B"};